import type { Locale } from '@/i18n/translations';

export const verificationCopy: Record<
  Locale,
  { title: string; description: string; close: string }
> = {
  ro: {
    title: 'Verificare de securitate',
    description: 'Pentru a continua în siguranță, finalizează verificarea de mai jos.',
    close: 'Renunță',
  },
  en: {
    title: 'Security check',
    description: 'Complete the check below to continue securely.',
    close: 'Cancel',
  },
  hu: {
    title: 'Biztonsági ellenőrzés',
    description: 'A biztonságos folytatáshoz végezd el az alábbi ellenőrzést.',
    close: 'Mégse',
  },
};
